import { render, staticRenderFns } from "./Post_List_Loading.vue?vue&type=template&id=5486b046&"
import script from "./Post_List_Loading.vue?vue&type=script&lang=js&"
export * from "./Post_List_Loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports